import { SectionFieldModel } from '@types'

import { Container, Label } from './SubmitterFieldSection.styled'

type SubmitterFieldSectionProps = {
  field: SectionFieldModel
}

export const SubmitterFieldSection: React.FC<SubmitterFieldSectionProps> = ({ field }: SubmitterFieldSectionProps) => {
  return (
    <Container id={field.id}>
      <Label>{field.label}</Label>
    </Container>
  )
}
